<div *ngIf="asset">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.asset' | transloco}} {{asset.alias}} ({{asset.organization.name}})
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            (click)="showSharedDialog(asset)"
            [label]="'misc.sharedPopUp.share' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            icon="pi pi-share-alt"
          ></button>
          <button
            *ngIf="'ROLE_ADMIN' | userHasRole"
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            icon="pi pi-pencil"
            routerLink="../edit"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="asset.description" class="text-xl">{{'attribute.description' | transloco}}: {{asset.description}}</p>
        <p *ngIf="!asset.description" class="font-italic text-xl">{{'empty.description' | transloco}}</p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="hidden xl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div *ngIf="items" class="with-margin">
    <app-asset-overview [asset]="asset" *ngIf="activeItem.id == 'overview'"></app-asset-overview>
    <app-asset-sensors [asset]="asset" *ngIf="activeItem.id == 'sensors'"></app-asset-sensors>
    <app-asset-measures [asset]="asset" *ngIf="activeItem.id == 'measures'"></app-asset-measures>
    <app-asset-triggers [asset]="asset" *ngIf="activeItem.id == 'triggers'"></app-asset-triggers>
    <app-asset-events [asset]="asset" [navState]="navState" *ngIf="activeItem.id == 'events'"></app-asset-events>
    <app-asset-devices [asset]="asset" *ngIf="activeItem.id == 'devices'"></app-asset-devices>
    <app-asset-technical-details [asset]="asset" *ngIf="activeItem.id == 'technicalDetails'"></app-asset-technical-details>
  </div>
</div>

<app-share-entity-dialog *ngIf="showDialog"
                         [sharedResources]="sharedResources"
                         [(dialogVisible)]="showDialog">
</app-share-entity-dialog>
